import type { ObjectDocumentAiDocumentType } from '@econtractor/types';
import { safeFloatParse } from 'utils/helpers/safeParsing';

export const hasPaymentAiValues = (document: Partial<ObjectDocumentAiDocumentType>): boolean =>
    Boolean(
        String(document.proposalAmount || '').trim() ||
            String(document.generationComment || '').trim() ||
            String(document.proposalName || '').trim() ||
            String(document.proposalNumber || '').trim(),
    );

export const buildPaymentDescriptionFromAi = (parsed: Partial<ObjectDocumentAiDocumentType>): string => {
    const comment = String(parsed.generationComment || '').trim();
    if (comment) return comment.slice(0, 500);

    const name = String(parsed.proposalName || '').trim();
    const number = String(parsed.proposalNumber || '').trim();
    if (name && number) return `${name} №${number}`.slice(0, 500);
    return (name || number).slice(0, 500);
};

/** Нормалізує суму з документа під валюту форми оплати (USD при rate≠1, інакше UAH). */
export const normalizePaymentAmountFromAi = (
    amountRaw: string | number | null | undefined,
    pricesInUsd: boolean | null | undefined,
    rate: number,
): number => {
    const amount = safeFloatParse(amountRaw || 0);
    if (!Number.isFinite(amount) || amount === 0) return 0;

    const safeRate = Number(rate) > 0 ? Number(rate) : 1;
    const isUahMode = safeRate === 1;

    if (isUahMode) {
        if (pricesInUsd === true) return amount;
        return amount;
    }

    if (pricesInUsd === false) {
        return Number((amount / safeRate).toFixed(2));
    }

    return amount;
};
